import { render, staticRenderFns } from "./Accidents.vue?vue&type=template&id=5f37e751&"
import script from "./Accidents.vue?vue&type=script&lang=js&"
export * from "./Accidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports